module.exports = __webpack_public_path__ + "img/room-3.59172b9b.jpg";